import React from 'react';
import { PenLine, Share2, Wallet } from 'lucide-react';

const steps = [
  { n: '01', title: 'Créez votre cagnotte', text: 'Choisissez Joyeuse ou Yako, racontez votre histoire, fixez votre objectif en FCFA.', Icon: PenLine },
  { n: '02', title: 'Partagez largement', text: "Diffusez le lien sur WhatsApp, les réseaux sociaux. Vos proches participent en quelques secondes.", Icon: Share2 },
  { n: '03', title: 'Recevez les fonds', text: 'Retirez via Wave, Orange Money, MTN, Moov. Sécurisé, transparent, rapide.', Icon: Wallet },
];

export default function HowItWorks() {
  return (
    <section id="how" className="relative">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 pb-20">
        <div className="text-[11px] tracking-[0.18em] uppercase font-medium text-neutral-500">3 étapes</div>
        <h2 className="mt-2 text-[clamp(2rem,4vw,3.4rem)] leading-[1.05] font-semibold tracking-tight text-[#1a1d1a]">Comment ça marche</h2>
        <div className="mt-10 grid md:grid-cols-3 gap-5">
          {steps.map(({ n, title, text, Icon }) => (
            <div key={n} className="relative rounded-3xl bg-white border border-black/5 p-7 card-lift overflow-hidden">
              <div className="absolute -right-2 -top-3 text-[120px] leading-none font-semibold text-neutral-100 select-none">{n}</div>
              <Icon className="w-6 h-6 text-[#d97757]" />
              <h3 className="mt-5 text-[20px] font-semibold text-[#1a1d1a]">{title}</h3>
              <p className="mt-2 text-[14px] text-neutral-600 max-w-xs">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
